var _path;
import * as React from "react";
function SvgClockFill(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2a18 18 0 110 36 18 18 0 010-36zm-1.688 8.438V20c0 .563.282 1.09.753 1.406l6.75 4.5c.773.52 1.82.31 2.341-.47.52-.781.31-1.822-.47-2.342L21.687 19.1v-8.663c0-.935-.753-1.687-1.688-1.687-.935 0-1.688.752-1.688 1.688z"
  })));
}
export default SvgClockFill;